var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgIconRingGroup = function SvgIconRingGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 15",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 7.167a3.33 3.33 0 0 1-2.756-1.458A4.163 4.163 0 0 0 3.916 8a3.333 3.333 0 0 1 2.897 4.828 4.169 4.169 0 0 0 2.374 0A3.333 3.333 0 0 1 12.084 8a4.162 4.162 0 0 0-1.328-2.292A3.33 3.33 0 0 1 8 7.167Zm0 7.5c.852 0 1.662-.183 2.392-.512a3.333 3.333 0 1 0 3.428-5.717 5.828 5.828 0 0 0-2.493-4.397 3.333 3.333 0 1 0-6.654 0A5.828 5.828 0 0 0 2.18 8.438a3.333 3.333 0 1 0 3.428 5.717c.73.329 1.54.512 2.392.512ZM9.667 3.833a1.667 1.667 0 1 1-3.334 0 1.667 1.667 0 0 1 3.334 0Zm-4.167 7.5a1.667 1.667 0 1 1-3.333 0 1.667 1.667 0 0 1 3.333 0Zm8.333 0a1.667 1.667 0 1 1-3.333 0 1.667 1.667 0 0 1 3.333 0Z"
  })));
};

export default SvgIconRingGroup;